import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./userList.css";

function UserDetails() {
    const { id } = useParams(); // Get user ID from URL
    const [user, setUser] = useState(null); // Store user details
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch user details from backend
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/hourlyParkingUser/${id}`);
                setUser(response.data);
            } catch (err) {
                setError(err.response ? err.response.data.message : err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [id]);

    return (
        <div className="aboutHourlyUser container mt-4 mb-4">
            <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>⬅ Back</button>
            <h2>Hourly User Details</h2>

            {loading && <p>Loading...</p>}
            {error && <p className="text-danger">Error: {error}</p>}

            {user && (
                <div className="userDetail row">
                    {/* Vehicle Image Section */}
                    <div className="col-md-4 mb-3">
                        <div className="vehicleImage card p-3">
                            <img
                                src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${user?.vehicleImage.split("\\").pop()}`}
                                alt="Vehicle"
                                className="img-fluid"
                            />
                        </div>
                    </div>

                    {/* User & Vehicle Details Section */}
                    <div className="col-md-8">
                        <div className="userName card p-3">
                            <h4>Customer Name: {user.customerName}</h4>
                        </div>

                        <div className="row mt-3">
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card1 card p-3 text-center">
                                    <h5>Vehicle Number</h5>
                                    <p>{user.vehicleNumber}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card2 card p-3 text-center">
                                    <h5>Vehicle Type</h5>
                                    <p>{user.vehicleType}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card3 card p-3 text-center">
                                    <h5>Parking Slot</h5>
                                    <p>{user.parkingSlot}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card4 card p-3 text-center">
                                    <h5>Vehicle Entry Time</h5>
                                    <p>{user.entryTime}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card5 card p-3 text-center">
                                    <h5>Vehicle Entry Date</h5>
                                    <p>{new Date(user.createdAt).toLocaleDateString()}</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3">
                                <div className="card6 card p-3 text-center">
                                    <h5>Customer Contact No</h5>
                                    <p>{user.contactNumber}</p>
                                    <h5>Customer Email Id</h5>
                                    <p>{user.email || "N/A"}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-12 col-sm-6 mb-3">
                                <div className="card7 card p-3 text-center">
                                    <h4>Exit the Vehicle</h4>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="flexSwitchCheckDefault"
                                            style={{
                                                width: "80px",
                                                height: "25px",
                                                border: "2px solid #022bc0",
                                                borderRadius: "25px"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

export default UserDetails;
